import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { addStructuredData, getOrganizationSchema, getLocalBusinessSchema, getWebSiteSchema } from './utils/seo'

const app = createApp(App)
    .use(store)
    .use(router)

// Initialize structured data
addStructuredData(getOrganizationSchema())
addStructuredData(getLocalBusinessSchema())
addStructuredData(getWebSiteSchema())

app.mount('#app')
